/** The error's message, or the stringified value for non-Error throws. */
export const toErrorMessage = (error: unknown): string =>
	error instanceof Error ? error.message : String(error);

const CLERK_OFFLINE_ERROR_CODE = "clerk_offline";
const CLERK_OFFLINE_ERROR_NAME = "ClerkOfflineError";

/**
 * True when Clerk rejected because the browser is offline. Matches on `code`
 * or `name` rather than `instanceof` so cross-bundle instances qualify, like
 * Clerk's own `ClerkOfflineError.is`. Contract pinned against @clerk/shared
 * 4.20.0 (`ClerkOfflineError.ERROR_CODE`) in libraries/ui/test/trpc.
 */
export function isClerkOfflineError(err: unknown): boolean {
	if (typeof err !== "object" || err === null) {
		return false;
	}
	const { code, name } = err as { code?: unknown; name?: unknown };
	return code === CLERK_OFFLINE_ERROR_CODE || name === CLERK_OFFLINE_ERROR_NAME;
}

/**
 * `data.errorCode` of a tRPC client error, or null. Reads a TRPCClientError,
 * the plain object a rejected mutation may carry, and anything else without
 * trusting the shape; every "switch on the code, localize" reader uses this.
 */
export function readTrpcErrorCode(error: unknown): string | null {
	if (typeof error !== "object" || error === null) {
		return null;
	}
	const { data } = error as { data?: unknown };
	if (typeof data !== "object" || data === null) {
		return null;
	}
	const { errorCode } = data as { errorCode?: unknown };
	return typeof errorCode === "string" ? errorCode : null;
}
